import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/styles";
import useTitle from "utils/custom-hooks/useTitle";
import theme from "theme/default";
import {
  borderRadius,
  fontWeight,
  fontSize,
  gradients,
  padding,
} from "theme/defaultStyle";
import GradientIcon from "theme/icons/GradientIcon";
import ExceptionsIcon from "theme/icons/ExceptionsIcon";
import TabNavigator from "controls/global/tab-navigator/TabNavigator";
import { TabNavigatorItem } from "entities/UIModel";
import PolicyDataErrorsTab from "./policy-data-errors/PolicyDataErrorsTab";
import { SAMPLE_EXCEPTION_RECORDS } from "./sampleExceptionsData";

const Container = styled("div")({
  backgroundColor: theme.palette.background.default,
  borderBottomLeftRadius: borderRadius.xlarge,
  borderBottomRightRadius: borderRadius.xlarge,
  position: "relative",
  "& .header": {
    display: "flex",
    alignItems: "center",
  },
  "& .headerContainer": {
    display: "flex",
    alignItems: "center",
    height: "28px",
    margin: "40px 0px 20px 0px",
    justifyContent: "space-between",
  },
  "& .titleQuickReferenceCard": {
    background: gradients.redGradient03,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: fontWeight.bold2,
    fontSize: fontSize.xlarge2,
    paddingLeft: padding.small1,
  },
});

type ExceptionsHomeProps = {
  saveFileRef: any;
  saveFileChangeRef: any;
  tabSaveChangesRef?: any;
};

const tabs: TabNavigatorItem[] = [
  { title: "Policy Data Errors", disabled: false },
];

const ExceptionsHome = ({
  saveFileRef,
  saveFileChangeRef,
  tabSaveChangesRef,
}: ExceptionsHomeProps) => {
  useTitle("Stewart Connect Policy Portal - Exceptions");

  return (
    <Container>
      <Box className="headerContainer">
        <Box className="header">
          <GradientIcon Icon={ExceptionsIcon} />
          <Typography
            className="titleQuickReferenceCard"
            variant="h6"
          >
            Exceptions
          </Typography>
        </Box>
      </Box>

      <TabNavigator
        tabs={tabs}
        tabSaveChangesRef={tabSaveChangesRef}
      >
        {[
          <PolicyDataErrorsTab key="policyDataErrors" records={SAMPLE_EXCEPTION_RECORDS} />,
        ]}
      </TabNavigator>
    </Container>
  );
};

export default ExceptionsHome;
